export default "__VITE_ASSET__Q_bpDxix__"